import {
  ENG_SEGMENT_LIST_ACTION,
  ENG_SEGMENT_CREATE_ACTION,
  ENG_SEGMENT_PREVIEW_ACTION,
  ENG_TEMPLATE_LIST_ACTION,
  ENG_CAMPAIGN_LIST_ACTION,
  ENG_CAMPAIGN_CREATE_ACTION,
  ENG_CAMPAIGN_LAUNCH_ACTION,
  ENG_CAMPAIGN_PAUSE_ACTION,
  ENG_CAMPAIGN_CANCEL_ACTION,
  ENG_CAMPAIGN_ANALYTICS_ACTION,
  ENG_RESET_MUTATION,
} from "./types";

export const engSegmentListAction = (data) => ({ type: ENG_SEGMENT_LIST_ACTION, payload: data });
export const engSegmentCreateAction = (data) => ({ type: ENG_SEGMENT_CREATE_ACTION, payload: data });
export const engSegmentPreviewAction = (id) => ({ type: ENG_SEGMENT_PREVIEW_ACTION, payload: id });

export const engTemplateListAction = (data) => ({ type: ENG_TEMPLATE_LIST_ACTION, payload: data });

export const engCampaignListAction = (data) => ({ type: ENG_CAMPAIGN_LIST_ACTION, payload: data });
export const engCampaignCreateAction = (data) => ({ type: ENG_CAMPAIGN_CREATE_ACTION, payload: data });
export const engCampaignLaunchAction = (id) => ({ type: ENG_CAMPAIGN_LAUNCH_ACTION, payload: id });
export const engCampaignPauseAction = (id) => ({ type: ENG_CAMPAIGN_PAUSE_ACTION, payload: id });
export const engCampaignCancelAction = (id) => ({ type: ENG_CAMPAIGN_CANCEL_ACTION, payload: id });
export const engCampaignAnalyticsAction = (id) => ({ type: ENG_CAMPAIGN_ANALYTICS_ACTION, payload: id });

export const engResetMutation = () => ({ type: ENG_RESET_MUTATION });
